const STORAGE_KEY = 'paint_ai_client_id';

let cached: string | undefined;

/**
 * Anonymous, per-browser id that scopes generation history on the server.
 * Persisted in localStorage; falls back to a per-tab id when storage is blocked.
 */
export function getClientId(): string {
  if (cached) return cached;
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return (cached = stored);
    cached = crypto.randomUUID();
    localStorage.setItem(STORAGE_KEY, cached);
  } catch {
    cached ??= crypto.randomUUID();
  }
  return cached;
}
